import { render, staticRenderFns } from "./EditAutoDeliveryCancelFinalModal.vue?vue&type=template&id=80c64c90&scoped=true&lang=pug&"
import script from "./EditAutoDeliveryCancelFinalModal.vue?vue&type=script&lang=js&"
export * from "./EditAutoDeliveryCancelFinalModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoDeliveryCancelFinalModal.vue?vue&type=style&index=0&id=80c64c90&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c64c90",
  null
  
)

export default component.exports